// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationTop_notification__2IybT","error":"NotificationTop_error__J8gvH","success":"NotificationTop_success__2Vo_-"};